import { render, staticRenderFns } from "./Badge6.vue?vue&type=template&id=67de58dc&scoped=true"
import script from "./Badge6.vue?vue&type=script&lang=js"
export * from "./Badge6.vue?vue&type=script&lang=js"
import style0 from "./Badge6.vue?vue&type=style&index=0&id=67de58dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de58dc",
  null
  
)

export default component.exports